import { getPageUrl, mapDocumentUrlToCategoryType } from '@/utils/helpers';

import resolveBool from './resolveBool';
import resolveCategories from './resolveCategories';
import resolveDate from './resolveDate';
import resolveImage from './resolveImage';
import resolvePerson from './resolvePerson';
import resolveReference from './resolveReference';
import resolveRTC from './resolveRTC';

const wrapUrl = ({ url = '', vanityUrl = '' }: { url: string; vanityUrl: string }): string => {
  if (!vanityUrl && url) return url;
  if (!url) return '';

  return url.replace(/[^/]+$/, vanityUrl.replace(/^\//, ''));
};

const resolveDocument = ({ rawVal, page, pageModels }: PropsWithCMSProps<DocumentProps>) => {
  const document = resolveReference<any>({ rawVal, page }) || {};

  const {
    title,
    headline,
    shortDescription,
    publicationDate,
    url,
    author,
    logo,
    imagecompound,
    metadataCompound,
    cardTileImage,
    cardLink,
    cardLinkNewWindow,
    cardTextLink,
    cardSecondaryButton,
    keys,
    cardReadTime,
    releaseDate,
    cardBackgroundImage: documentCardBackgroundImage,
  } = document;

  const categoryType = mapDocumentUrlToCategoryType({ url });
  const { vanityUrl, metaTitle, metaDescription, description } = metadataCompound || {};
  const cardImage = resolveImage({ rawVal: imagecompound || cardTileImage, page });
  const cardBackgroundImage = resolveImage({ rawVal: documentCardBackgroundImage, page });
  const categories = resolveCategories({ rawVal: keys, categoryType, pageModels });
  const cardPubDate = resolveDate({ rawVal: publicationDate });
  const cardRelDate = resolveDate({ rawVal: releaseDate });

  return {
    heading: metaTitle || title || headline,
    logo: resolveImage({ rawVal: logo, page }),
    image: cardImage,
    publicationDate: cardPubDate,
    url: page && getPageUrl({ url: wrapUrl({ vanityUrl, url }), page }),
    author: resolvePerson({ rawVal: author, page }),
    category: categories,
    cardCategory: categories ? categories[0] : '',
    cardPublicationDate: cardPubDate,
    categoryType,
    shortDescription,
    cardLink,
    cardLinkNewWindow: resolveBool({ rawVal: cardLinkNewWindow }), // Only used in "PressCenterResource"
    cardTextLink,
    cardSecondaryButton,
    cardReadTime,
    cardHeading: metaTitle || title || headline,
    cardDescription: description || metaDescription || resolveRTC({ rawVal: shortDescription }),
    cardImage,
    cardBackgroundImage,
    cardLogo: resolveImage({ rawVal: logo, page }),
    releaseDate: cardRelDate,
  };
};

export default resolveDocument;
